<template>
  <div class="van-uploader">
    <template v-if="multiple && value">
      <div class="van-uploader__wrapper">
        <div class="van-uploader__upload" @click="handlePickFile()">
          <i class="van-icon van-icon-plus van-uploader__upload-icon"><!----></i>
          <div class="van-uploader__input"></div>
        </div>
      </div>
      <div v-for="(fileId, index) in value.split(',')" class="van-uploader__wrapper">
        <div class="van-uploader__preview">
          <div class="van-image van-uploader__preview-image" style="overflow: hidden; border-radius: 4px;">
            <img :src="getPreviewUrl(fileId)" v-if="isImage(fileId)" class="van-image__img" style="object-fit: cover;"/>
            <div v-else><img src="@/assets/file.png" alt="" style="width: 60px;height: 60px;"/></div>
          </div>
        </div>
        <div class="preview" @click="previewFile(getPreviewUrl(fileId))">查看文件 &gt;</div>
        <div class="delete" @click="deleteFile(fileId)">X</div>
      </div>
    </template>
    <template v-else>
      <div class="van-uploader__wrapper">
        <template v-if="value">
          <div class="van-uploader__preview" @click="handlePickFile()">
            <div class="van-image van-uploader__preview-image" style="overflow: hidden; border-radius: 4px;">
              <img :src="filePreviewUrl" v-if="isImage(value)" class="van-image__img" style="object-fit: cover;"/>
              <div v-else><img src="@/assets/file.png" alt="" style="width: 60px;height: 60px;"/></div>
              <!-- <img src="" class="van-image__img" style="object-fit: cover;"> -->
            </div>
          </div>
        </template>
        <div v-else class="van-uploader__upload" @click="handlePickFile()">
          <i class="van-icon van-icon-plus van-uploader__upload-icon"><!----></i>
          <div class="van-uploader__input"></div>
        </div>
      </div>
      <div v-if="filePreviewUrl" class="preview" @click="previewFile(filePreviewUrl)">查看文件 &gt;</div>
    </template>
    <van-action-sheet v-model="showType" description="请选择方式" :actions="options" @select="onSelect" cancel-text="取消"
                      close-on-click-action @cancel="showType = false"/>
  </div>
</template>

<script>
import nativeApi from '@/utils/native-bridge.js';
import mixinLoad from '@/mixin/mixin-load.js';
import {previewUrl, previewFile} from '@/api/file.js';

export default {
  name: 'Upload',
  mixins: [mixinLoad],
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    type:{//类型有 身份证正面：idFront 身份证背面：idBack，通用：default
      type: String,
      default: null
    },
    params: {
      type: Object,
      default: () => {
        return {
          category:'',
          fileType: 'jpg,png,jpeg',
          fileMaxSize: '-1',
          fileMinSize: '-1',
          secrecyLevel: '0',
          imgMaxWidth: '-1',
          imgMaxHeidht: '-1',
          imgMinWidth: '-1',
          imgMinHeight: '-1',
          checkFile: '1'
        };
      }
    }
  },
  computed: {
    filePreviewUrl() {
      if (this.value) {
        return previewUrl(this.value);
      }
      return '';
    }
  },
  data() {
    return {
      showType: false,
      fileInfo: {},
      options: [
        {
          name: '相册'
        },
        {
          name: '拍照'
        },
        // {
        //   name: '文件'
        // }
      ]
    };
  },
  methods: {
    previewFile,
    getPreviewUrl(fileId) {
      return previewUrl(fileId);
    },
    isImage(url) {
      return url.endsWith('png') || url.endsWith('jpg') || url.endsWith('jpeg');
    },
    handlePickFile() {
      if (this.disabled) {
        return;
      }
      const requireParams = Object.assign({}, this.params);
      if (requireParams.fileType !== 'file') {
        this.showType = true;
      } else {
        this.invokePick(requireParams);
      }
    },
    deleteFile(fileId) {
      this.$dialog
          .confirm({
            title: '提示',
            message: '是否删除该文件？',
            confirmButtonText: '确定',
            cancelButtonText: '再想想'
          })
          .then(() => {
            let newVaule = this.value
                .split(',')
                .filter(item => {
                  return item != fileId;
                })
                .join(',');
            this.$emit('input', newVaule);
          });
    },
    onSelect(option) {
      const requireParams = Object.assign({}, this.params);
      if (option.name === '相册') {
        requireParams.fileType = 'img';
        this.invokePick(requireParams);
      } else if (option.name === '拍照') {
        //只有拍照时category才赋值，而且赋的是父传进来的type
        requireParams.category = this.type
        requireParams.fileType = 'img';
        this.invokeCamera(requireParams);
      } else {
        requireParams.fileType = 'file';
        this.invokePick(requireParams);
      }
      this.showType = false;
    },
    invokePick(requireParams) {
      const _this = this;
      nativeApi.uploadFile({
        params: requireParams,
        success: data => {
          _this.$nextTick(() => {
            if (_this.multiple) {
              if (!_this.value || _this.value === '') {
                _this.$emit('input', data);
              } else {
                _this.$emit('input', data + ',' + _this.value);
              }
            } else {
              _this.$emit('input', data);
            }
          });
          _this.showTip('上传成功');
        },
        cancel: () => {
          _this.showTip('已取消');
        },
        error: rep => {
          _this.showErrorTip(rep.msg);
        }
      });
    },
    invokeCamera(requireParams) {
      const _this = this;
      nativeApi.uploadCameraFile({
        params: requireParams,
        success: data => {
          _this.$nextTick(() => {
            if (_this.multiple) {
              if (!_this.value || _this.value === '') {
                _this.$emit('input', data);
              } else {
                _this.$emit('input', data + ',' + _this.value);
              }
            } else {
              _this.$emit('input', data);
            }
          });
          _this.showTip('上传成功');
        },
        cancel: () => {
          _this.showTip('已取消');
        },
        error: rep => {
          _this.showErrorTip(rep.msg);
        }
      });
    }
  }
};
</script>

<style scoped="scoped">
.van-uploader {
  display: flex;
  flex-wrap: wrap;
}

.van-uploader__wrapper {
  position: relative;
}

.preview {
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  left: 0px;
  right: 10px;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
}

.delete {
  font-size: 12px;
  position: absolute;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0px;
  right: 0px;
  height: 20px;
  width: 20px;
}
</style>



